import { useSyncExternalStore } from 'react'
import {
  getBackgroundPlacementOverridesSnapshot,
  subscribeBackgroundPlacementOverrides,
} from '@/lib/backgrounds/background-placement-session'

export function useBackgroundPlacementOverrides(): ReadonlyMap<string, boolean> {
  return useSyncExternalStore(
    subscribeBackgroundPlacementOverrides,
    getBackgroundPlacementOverridesSnapshot,
    getBackgroundPlacementOverridesSnapshot
  )
}
